export default __webpack_public_path__ + "static/media/calathea.455c33e2.jpg";